import React from 'react'

const ExperimentalUI = () => {
    return (
        <div style={{color:"red"}}>
            Experimental UI for A/B Testing
        </div>
    );
};

export default ExperimentalUI